module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/.deno/babel-runtime@6.26.0/~/babel-runtime/core-js/object/assign.js
// module id = 178
// module chunks = 0